import React from "react";
import Revenue from "./components/Revenure";
import Detail from "./components/Detail";
import ActivityLog from "./components/ActivityLog";
import { useSelector } from "react-redux";
import { dashboardStatisticOfficePropertySelector } from "../../../selectors/DashboardSelectors";

const TabPrivateOffices = () => {
  const dashboardStatisticProperty = useSelector(
    dashboardStatisticOfficePropertySelector
  );

  return (
    <div className={"dashboard_chart_wrapper"}>
      <Revenue data={dashboardStatisticProperty} />
      <Detail data={dashboardStatisticProperty} type={"private-offices"} />
      <ActivityLog />
    </div>
  );
};

export default TabPrivateOffices;
